<template>
  <div>
    <component v-for="column in myColumnList.filter(c => !c.detailviewHidden)" :is="column.component" :key="column.id" :formProperty="column"/>
    <div class="row justify-end q-pa-sm">
      <!--<q-btn color="primary" @click="btnBack()" unelevated size="md" data-test="backToQuery">Zurück</q-btn>-->
      <span v-if="editMode" style="width:20px"></span>
      <q-btn v-if="editMode" color="warning" unelevated @click="btnUpdate()" size="md" data-test="updateSingleRecord">{{ $t('update') }}</q-btn>
    </div>
  </div>
</template>

<script>
  import moment from 'moment'
  import {StaticData} from '../classes/StaticData'
  import {useQueryStore} from '../stores/QueryStore.js'

  export default {
    name: 'singleRecordView',

    props: ['queryID', 'columnList', 'selectedRow', 'editMode', 'paramList'],
    data() {
      return {
        StaticData,
        myColumnList: this.columnList
        /*
                queryID: this.$route.params.id,
                columnList: this.$route.params.columns,
                selectedRow: this.$route.params.selectedRow,
                editMode: this.$route.params.editMode,
        */
      }
    },

    methods: {

      btnUpdate() {
        let key = null;
        this.myColumnList.forEach(column => {
          if (column.primaryKey) key = column.value
        })

        if (!key) {
          this.eventBus.globalErrorHandling(this.$t('noPrimaryKeyError'))
          return
        }
        const queryStore = useQueryStore()
        //this.$q.loading.show({message: 'Update wird durchgeführt...'})
        this.$emit("showLoading", true)

        let updateRow = {}
        let updateCount = 0;
        this.myColumnList.forEach(column => {
          if (!column.readonly) updateCount++
          updateRow[column.name] = column.value
        })
        delete updateRow.__key__

        let myParameter = Object.assign([], this.paramList)
        myParameter = myParameter.map((param) => {
          return {name: param.name, value: param.value}
        })

        //var a = [{'a': 1}, {'b': 2}]
        let allPromises = new Array(updateCount);
        let i = 0;
        this.myColumnList.forEach(column => {
          if (!column.readonly) {
            let value = column.value == "" ? null : column.value
            allPromises[i++] = queryStore.queryCellUpdate({key, cellname: column.field, cellvalue: value, queryID: this.queryID, row: updateRow, queryParameter: myParameter})
          }
        })

        Promise.all(allPromises).then(response => {
          console.log(response)
          this.$q.notify({color: "positive", message: i == 1 ? this.$t('updateSuccess') : this.$t('updateSuccess')})
          this.$emit("closeSingleRecordView")

        }, error => {
          console.log(error)  // " + column.field + "
          this.$emit("showLoading", false)
          this.eventBus.globalErrorHandling(this.$t('fieldUpdateError'), error)
        })
      }
    },

    mounted: function () {
      console.log("in SingleRecordView - this.selectedRow:", this.selectedRow, ", EDIT:", this.editMode)
      let srvColList = new Array()
      let i = 0
      const queryStore = useQueryStore()
      let mySelectedRow = Object.assign({}, this.selectedRow)

      for (let key in mySelectedRow) {
        if (this.selectedRow.hasOwnProperty(key)) {

          let col = Object.assign({}, this.myColumnList[i++])
          if (!col) break;

          col.title = col.label // key
          col.nativename = col.name
          col.id = col.id == "" ? i : col.id
          col.value = mySelectedRow[key]

          //col.component = fldString
          col.paramInfoFormat = ""
          col.paramInfoTooltip = ""
          col.floatLabel = ""
          col.paramInfoTooltip = ""
          col.primaryKey = col.primaryKey

          if (col.projectionUpdateable) col.readonly = false
          else col.readonly = true

          switch (col.datatypeID) {
            case StaticData.DATATYPES.TYPE_INT:
            case StaticData.DATATYPES.TYPE_LONG:
            case StaticData.DATATYPES.TYPE_INT64:
            case StaticData.DATATYPES.TYPE_DOUBLE:
              col.component = "fldNumber"
              col.valueMin = 0
              col.valueMax = 99999
              col.lengthMax = 10
              col.lengthMin = 0
              col.value = parseInt(col.value).toFixed(0)
              break

            case StaticData.DATATYPES.TYPE_FLOAT:
              col.component = "fldFloat"
              col.valueMin = 0
              col.valueMax = 99999
              col.lengthMax = 10
              col.lengthMin = 0
              col.paramCommaPost = 2
              col.paramCommaPre = 10
              //item.component = fldOCR;
              break

            case StaticData.DATATYPES.TYPE_STRING:
            case StaticData.DATATYPES.TYPE_MEMO:
              col.component = "fldString"
              break

            case StaticData.DATATYPES.TYPE_BOOLEAN:
              col.component = "fldString"
              break

            case StaticData.DATATYPES.TYPE_DATE:
              col.dataTypeID = StaticData.DATATYPES.TYPE_DATE
              col.value = moment(col.value, "DD.MM.YYYY HH:mm:SSS").format("YYYY/MM/DD")
              col.component = "fldDateTime";
              break

            case StaticData.DATATYPES.TYPE_TIME:
              col.dataTypeID = StaticData.DATATYPES.TYPE_TIME

            case StaticData.DATATYPES.TYPE_DATETIME:
              col.dataTypeID = StaticData.DATATYPES.TYPE_DATETIME
              col.component = "fldDateTime";
              col.value = moment(col.value, "DD.MM.YYYY HH:mm:SSS").format("YYYY/MM/DD HH:mm:SS")
              break

            case StaticData.DATATYPES.TYPE_VALUELIST:
              if (col.projectionUpdateable) {
                col.component = "fldValueList"
                col.errorFetchingData = false
                col.errorMsg = ""

                if (col.valuelistType === 2) {
                  queryStore.queryCellUpdateValueListDomainGet({queryID: this.queryID, cellname: col.name})
                    .then(response => {
                      response = response.valueListValues
                      this.eventBus.refreshComp(col.name, response)
                    })
                    .catch((error) => {
                      this.eventBus.refreshComp(col.name, "", true, error.response.data.sErrorMsg)
                      this.eventBus.globalErrorHandling(this.$t('valuedomainColumnStart') + col.name + this.$t('valuedomainColumnEnd'), error)
                    })
                } else {
                  col.valueList = col.projectionValuelist
                }
              } else {
                col.component = "fldString"
              }
              break
          }

          if (!this.editMode) col.readonly = true

          srvColList.push(col)
        }
      }

      this.myColumnList = srvColList
    }
  }
</script>
